import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Barbell } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { extractError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", username: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to Spotter");
      navigate("/feed");
    } catch (err) {
      const msg = extractError(err, "Registration failed");
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-4 grid-bg">
      <div className="w-full max-w-md fade-in">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-8 h-8 bg-[#FF3B30] flex items-center justify-center">
            <Barbell size={20} weight="bold" color="#0A0A0A" />
          </div>
          <span className="font-display text-3xl font-black tracking-tight">SPOTTER</span>
        </Link>

        <div className="border border-[#27272A] bg-[#121212] p-8">
          <div className="text-xs uppercase tracking-widest text-[#FF3B30] font-mono mb-2">// Join</div>
          <h1 className="font-display text-4xl font-black uppercase mb-8">Create account</h1>

          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-semibold block mb-1">Name</label>
              <input data-testid="register-name-input" required value={form.name} onChange={set("name")} placeholder="Alex Ironheart" className="input-line" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-semibold block mb-1">Username</label>
              <input data-testid="register-username-input" required minLength={2} value={form.username} onChange={set("username")} placeholder="ironalex" className="input-line" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-semibold block mb-1">Email</label>
              <input data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} placeholder="you@example.com" className="input-line" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-semibold block mb-1">Password</label>
              <input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={set("password")} placeholder="Min 6 characters" className="input-line" />
            </div>

            {error && (
              <div data-testid="register-error" className="border border-[#FF3B30] bg-[#FF3B30]/10 text-[#FF3B30] text-sm px-3 py-2">
                {error}
              </div>
            )}

            <button data-testid="register-submit-button" type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? "Creating..." : "Create account"}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-[#27272A] text-sm text-zinc-500 text-center">
            Have an account?{" "}
            <Link to="/login" data-testid="register-to-login-link" className="text-white hover:text-[#FF3B30] font-semibold uppercase tracking-wider text-xs">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
